export default __webpack_public_path__ + "static/media/Group625@2x.e19220fd.png";